import React from 'react'

export const Footer = () => {
  return (
    <>
    <footer className='bg-cyan-950'>
    <hr className="border-zinc-200 sm:mx-auto" />
        <span className="block text-sm text-gray-500 text-center py-3 dark:text-gray-400 text-zinc-200">Made with ❤️ by <span className='text-red-300'>Henna Maria</span></span>
    </footer>
    </>
  )
}
